// extracted by mini-css-extract-plugin
module.exports = {"WinnerBox":"style_WinnerBox__1x4UL"};